import { Component, ViewContainerRef } from '@angular/core';
import { ManuManagement } from '../../models/manu-management/manu-management-model';
import { ManuManagementService } from '../../services/manu-mangement/manu-management.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router, ActivatedRoute, Params } from "@angular/router";
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
    selector: 'app-edit-menu-management',
    templateUrl: './edit-menu-management.component.html',
    styleUrls: ['./edit-menu-management.component.css']
})
/** edit-menu-management component*/
export class EditMenuManagementComponent {
    /** edit-menu-management ctor */
  public manu = new ManuManagement();
  validate: boolean;
  constructor(private readonly manuMangementService: ManuManagementService, public toastr: ToastsManager, vcr: ViewContainerRef,
    private readonly router: Router, private _avRoute: ActivatedRoute, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("menumanagement").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0) {
            if (this._avRoute.snapshot.params["id"]) {
              this.manu = new ManuManagement();
              this.getMenuById(this._avRoute.snapshot.params["id"]);
              this.toastr.setRootViewContainerRef(vcr);
              this.validate = true;
            }

          }
          else {
            this.router.navigate(["/manu-list"]);
          }
        }
        else {
          this.router.navigate(["/manu-list"]);
        }
      }
    )
  }
  getMenuById(id: string) {
    this.manuMangementService.getManuById(id).subscribe(
      data => {
        this.manu = data;
      }
    )
  }
  isActiveCheckbox(e) {
    this.manu.isActive = e.target.checked;
  }
  onSubmit() {
    this.validate = false;
    this.manuMangementService.updateManu(this.manu).subscribe(result => {
      if (result) {
        this.toastr.success('Menu has been Updated.', 'Success');
        setTimeout(() => {
          this.router.navigate(["/manu-list"]);
        }, 2000);
      }
      else {
        this.toastr.error('Error occurred. Oop!', 'Error');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/manu-management-component/edit-menu-management/edit-menu-management.component.ts